import React, { useMemo, useState } from 'react';
import { Box } from 'native-base';
import { Caption, H3 } from '~/shared/Typography';
import { SpIcon } from '~/shared/Icon';
import { faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { useI18n, useSpringBigStore } from '@springbig/shared';
import GiftCardInboxModal from './GiftCardInboxModal';
import { Button, Panel } from './Theme';

const GiftCardNotificationBanner = () => {

    const { member, merchant } = useSpringBigStore();
    const { t } = useI18n();

    const hasUnclaimedGiftCards = useMemo(() => {

        return member?.reward_grants?.some((r) => r._type === 'gift_card' && r.active);
    }, [member]);

    const hasAutoClaimNotifications = useMemo(() => {

        return member?.active_notifications?.some((n) => n.message_type === 'gift_card_auto_claimed');
    }, [member]);

    const [isInboxModalOpen, setIsInboxModalOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);

    const openGiftCardInbox = () => {

        setIsInboxModalOpen(true);
    };

    const closeInboxModal = () => {

        setIsInboxModalOpen(false);
    };

    const toggleExpanded = () => {

        setIsExpanded(!isExpanded);
    };

    const closeAndCollapse = () => {

        setIsInboxModalOpen(false);
        setIsExpanded(false);
    };

    const currentArrow = useMemo(() => (isExpanded ? faArrowUp : faArrowDown), [isExpanded]);

    if (!hasUnclaimedGiftCards && !hasAutoClaimNotifications) {
        return null;
    }

    return (
        <>
            <Panel
                p={2}
                alignItems={'center'}
                textAlign={'center'}
                position={'relative'}
            >
                <Button
                    position={'absolute'}
                    top={0}
                    left={0}
                    padding={3}
                    onPress={toggleExpanded}
                    bg={'transparent'}
                    borderColor={'transparent'}
                >
                    <SpIcon
                        icon={currentArrow}
                    />
                </Button>
                <H3>
                    { t('giftCard.inboxBannerHeading', [merchant?.gift_card_alias]) }
                </H3>
                <Box display={isExpanded ? 'flex' : 'none'}>
                    <Caption marginBottom={2}>
                        { t('giftCard.inboxBannerSubHeading', [merchant?.gift_card_alias]) }
                    </Caption>
                    <Button
                        onPress={openGiftCardInbox}
                        text={'giftCard.inboxBannerButton'}
                    />
                </Box>
            </Panel>
            <GiftCardInboxModal
                isOpen={isInboxModalOpen}
                close={closeInboxModal}
                closeAndCollapse={closeAndCollapse}
            />
        </>
    );
};

export default GiftCardNotificationBanner;
